export default "__VITE_ASSET__CAOi$3fn__"